const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
      .show {
        display: flex;
      }
      .hide {
        display: none;
      }
      .modal {
        position: fixed;
        z-index: 1;
        padding-top: 100px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.4);
      }
      .modal-content {
        background-color: #fefefe;
        margin: auto;
        padding: 20px;
        border: 1px solid #888;
        max-width: 40%;
        max-height: 72%;
        border-radius: 8px;
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
        margin-top: 2%;
      }

      .modal-content::-webkit-scrollbar {
          width: 0;
          height: 0;
      }

      .close {
        color: #aaaaaa;
        font-size: 28px;
        font-weight: bold;
      }

      .close:hover,
      .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
      }
      h2 {
        margin: 0;
      }
      .header {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
      }
      .space {
        margin-bottom: 30px;
      }
    </style>
</template>`;
styleElement.register("modal-faq-style");
